"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2C5.58172 2 2 5.58172 2 10V18C2 22.4183 5.58172 26 10 26H18C22.4183 26 26 22.4183 26 18V10.6375L16.2429 21.6142C15.0496 22.9567 12.9519 22.9567 11.7585 21.6142L4.82422 13.8131L8.18756 10.8235L14.0007 17.3633L24.585 5.4559C23.1415 3.36795 20.7305 2 18 2H10Z", fill: "currentColor" }));
